import fetch from '@/plugins/fetch'
import dayjs from 'dayjs'
import B_COUPON from '@/business/coupon'
import queryString from 'query-string'
import { PREFIX_CZJCAPI_API, PREFIX_SCC_API } from '@/service'
const api = {
  queryTicketDetail: `${PREFIX_CZJCAPI_API}spu/queryNewAdmissionTicketDetail.do`,
  queryBookingNotes: `${PREFIX_SCC_API}api/admissionTicket/queryBookingNotes.do`
}

export async function queryBookingNotes(skuId) {
  const params = {
    skuId
  }
  try {
    const query = queryString.stringify(params)
    const res = await fetch(`${api.queryBookingNotes}?${query}`)
    const response = await res.json()
    if (response.code == '1') {
      return response.data
    }
  } catch (e) {
    console.log(e)
  }
}

const KEYS = {
  PROMOTION: '优惠信息',
  APPOINT: '预订说明',
  EXPLAIN: '使用说明',
  OTHER: '其他说明'
}
const NoticeType = {
  COUPON: 1, //优惠劵
  APPOINTTIME: 2 //可订时间
}

const refund = { 0: '不可退', 1: '随时退' }
const changeTicket = { 0: '无需换票', 1: '需换票' }

export const getNoticeData = noticeInfo => {
  const noticeData = {}
  //优惠劵-----------
  if (noticeInfo.coupons && noticeInfo.coupons.length > 0) {
    noticeData[KEYS.PROMOTION] = {
      优惠券: {
        tag: noticeInfo.coupons.map(i => {
          return {
            title: getCouponText(i),
            userType: i.userType
          }
        }),
        type: NoticeType.COUPON
      }
    }
  }
  // 预订说明-----------
  const date = getAppointDate(
    noticeInfo.reserveDate,
    noticeInfo.reserveTime,
    noticeInfo.earliestBuyDate
  )
  let str = ''
  if (noticeInfo.reserveDate && noticeInfo.reserveTime) {
    if (AppointType.TODAY.toString() === noticeInfo.reserveDate) {
      str = `${noticeInfo.reserveTime}之前可订今日`
      if (date && date.isHideTitle) str = ''
    }
    if (AppointType.TOMORROW.toString() === noticeInfo.reserveDate) {
      str = `${noticeInfo.reserveTime}之前可订明日`
      if (date && date.isHideTitle) str = ''
    }
  }

  const refundStr = refund[noticeInfo.isAnyTimeRefund ?? -1]
  const changeTicketStr = changeTicket[noticeInfo.changeTicket ?? -1]
  noticeData[KEYS.APPOINT] = {}
  if (date || str) {
    noticeData[KEYS.APPOINT]['预订时间'] = {
      tag: date && date.tag,
      type: NoticeType.APPOINTTIME,
      info: str
    }
  }
  if (refundStr) {
    noticeData[KEYS.APPOINT][refundStr] = {
      info: noticeInfo.retreatRule
    }
  }
  if (changeTicketStr) {
    noticeData[KEYS.APPOINT][changeTicketStr] = {
      info: noticeInfo.entryMode
    }
  }

  if (noticeInfo.termOfValidity) {
    noticeData[KEYS.APPOINT]['有效期'] = {
      info: noticeInfo.termOfValidity
    }
  }
  //使用说明-----------
  noticeData[KEYS.EXPLAIN] = {}
  if (noticeInfo.scheduleExplain) {
    noticeData[KEYS.EXPLAIN]['预约说明'] = {
      info: noticeInfo.scheduleExplain
    }
  }
  if (noticeInfo.entryTime) {
    noticeData[KEYS.EXPLAIN]['入园时间'] = {
      info: noticeInfo.entryTime
    }
  }

  if (noticeInfo.entryAddress) {
    noticeData[KEYS.EXPLAIN]['入园地址'] = {
      info: noticeInfo.entryAddress
    }
  }
  //其他说明-----------
  noticeData[KEYS.OTHER] = {}
  if (noticeInfo.applyPeople) {
    noticeData[KEYS.OTHER]['适用人群'] = {
      info: noticeInfo.applyPeople
    }
  }
  if (noticeInfo.priceInclude) {
    noticeData[KEYS.OTHER]['费用包含'] = {
      info: noticeInfo.priceInclude
    }
  }
  if (noticeInfo.invoiceExplain) {
    noticeData[KEYS.OTHER]['发票说明'] = {
      info: noticeInfo.invoiceExplain
    }
  }
  if (noticeInfo.otherIntroduce) {
    noticeData[KEYS.OTHER]['补充说明'] = {
      info: noticeInfo.otherIntroduce
    }
  }

  Object.keys(noticeData).forEach(item => {
    const value = noticeData[item]
    if (Object.keys(value).length === 0) {
      delete noticeData[item]
    }
  })

  return {
    noticeData
  }
}

export const AppointType = {
  TODAY: 0, //今日
  TOMORROW: 1, //明日
  DATE: 2 //具体某个日期
}

export const getAppointDate = (reserveDate, reserveTime, earliestBuyDate) => {
  if (typeof reserveDate === 'number') {
    reserveDate = reserveDate + ''
  }
  if (!reserveDate) {
    return null
  }
  if (+reserveDate != AppointType.DATE && !reserveTime) {
    return null
  }
  if (+reserveDate === AppointType.DATE && !earliestBuyDate) {
    return null
  }
  const currentTime = dayjs()
  if (
    +reserveDate === AppointType.TODAY ||
    +reserveDate === AppointType.TOMORROW
  ) {
    const deadlineTime = dayjs(
      `${currentTime.year()}-${
        currentTime.month() + 1
      }-${currentTime.date()} ${reserveTime}`,
      'YYYY-M-D H:mm'
    )
    if (+reserveDate === AppointType.TODAY) {
      return currentTime.isAfter(deadlineTime)
        ? { tag: '可订明日', isHideTitle: true }
        : { tag: '可订今日', isHideTitle: false }
    } else {
      const afterTomorrow = currentTime.add(2, 'day')
      return currentTime.isAfter(deadlineTime)
        ? {
            tag: `可订${afterTomorrow.month() + 1}月${afterTomorrow.date()}日`,
            isHideTitle: true
          }
        : { tag: '可订明日', isHideTitle: false }
    }
  }
  if (+reserveDate === AppointType.DATE) {
    const time = dayjs(earliestBuyDate)
    if (time.isSame(currentTime, 'day')) {
      return { tag: '可订今日', isHideTitle: true }
    }
    const tomorrow = currentTime.add(1, 'day')
    if (time.isSame(tomorrow, 'day')) {
      return { tag: '可订明日', isHideTitle: true }
    }
    if (time.isAfter(currentTime)) {
      return {
        tag: `最早可订${time.month() + 1}月${time.date()}日`,
        isHideTitle: true
      }
    }
    return null
  }
}

const getCouponText = couponInfo => {
  const { couponType, couponAmount, useAmountLimit } = couponInfo
  if (B_COUPON.isFullReduce(couponType)) {
    return `满${useAmountLimit / 100}减${couponAmount / 100}`
  }
  return `${couponAmount / 100}元现金券`
}
